import {Mapper} from '@s-ui/domain'

export class FromPlaceholderUrlToPreviousPageUrl extends Mapper {
  map = ({currentPage, placeholder, url = ''}) => {
    const previousPage = currentPage - 1
    if (previousPage === 0) return
    return url.replace(placeholder, previousPage)
  }
}
